/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_Nav_FeaturesInputs */

const tr_landing_finalcta_nav_features = /** @type {(inputs: Landing_Finalcta_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellikler`)
};

const en_landing_finalcta_nav_features = /** @type {(inputs: Landing_Finalcta_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const de_landing_finalcta_nav_features = /** @type {(inputs: Landing_Finalcta_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

const ru_landing_finalcta_nav_features = /** @type {(inputs: Landing_Finalcta_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возможности`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Landing_Finalcta_Nav_FeaturesInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_nav_features = /** @type {((inputs?: Landing_Finalcta_Nav_FeaturesInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_Nav_FeaturesInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_nav_features(inputs)
	if (locale === "de") return de_landing_finalcta_nav_features(inputs)
	if (locale === "ru") return ru_landing_finalcta_nav_features(inputs)
	return tr_landing_finalcta_nav_features(inputs)
});